import React from 'react'
import IconGradeA from './IconGradeA'
import IconGradeB from './IconGradeB'
import IconGradeC from './IconGradeC'
import IconGradeD from './IconGradeD'

export const checkExistNutriGradeTag = (tags: string[]): string => {
  return tags?.find((tag) => tag.includes('nutrigrade'))
}

export const NutriGradeIcon = ({
  tags,
  width,
  height
}: {
  tags: string[]
  width: number
  height: number
}) => {
  const tagValue = checkExistNutriGradeTag(tags)
  if (!tagValue) return null
  const tagDetails = tagValue.split(':')[1]
  const group = tagDetails.split('-')[0]
  const value = tagDetails.split('-')[1]

  if (group === 'a')
    return <IconGradeA value={value} width={width} height={height} />
  if (group === 'b')
    return <IconGradeB value={value} width={width} height={height} />
  if (group === 'c')
    return <IconGradeC value={value} width={width} height={height} />
  if (group === 'd')
    return <IconGradeD value={value} width={width} height={height} />
  return null
}
